import { useEffect } from "react";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@shared/components/ui/Toast";
import { useToaster } from "@shared/hooks/useToaster";

export const Toaster = () => {
  const { toasts, hasToastDisplayed } = useToaster();

  useEffect(() => {
    // Hide/Show the Zendesk widget when a toast is displayed
    if (hasToastDisplayed) {
      window.hideSupport?.();
      window.hideDebug?.();
      window.hideDemo?.();
    } else {
      window.showSupport?.();
      window.showDebug?.();
      window.showDemo?.();
    }
  }, [hasToastDisplayed]);

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
